import PropTypes from 'prop-types'
import { useState } from 'react'

import { FormModal, Snackbar } from '../../default'
import { CreatePlanGroupForm } from '../../forms'

/**
 * @description UpdatePlanGroupModal function is a React component that renders a modal for updating a plan group.
 * 
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines whether the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @param {object} selectedPlanGroup - The selected plan group object to be updated.
 */
const UpdatePlanGroupModal = ({ open, onClose, selectedPlanGroup }) => {

    const [showSnackbar, setShowSnackbar] = useState(false)

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setShowSnackbar(false)
    }

    return (
        <>
            <FormModal
                title='Editar Grupo de Planos'
                id={selectedPlanGroup?.plan_group_id}
                open={open} onClose={onClose}
            >
                <CreatePlanGroupForm onClose={onClose} setShowSnackbar={setShowSnackbar} selectedPlanGroup={selectedPlanGroup} />
            </FormModal>
            <Snackbar
                open={showSnackbar}
                onClose={handleSnackbarClose}
                vertical='bottom'
                horizontal='right'
                severity='success'
                variant='filled'
                message='Grupo de Planos alterado com sucesso!'
                sx={{ mt: 1 }}
            />
        </>
    )

}

UpdatePlanGroupModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedPlanGroup: PropTypes.object
}

export default UpdatePlanGroupModal